import axios from "axios";
import { API_WATER_AUTHORITY } from "../../config/api";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  hideProgress,
  showProgress,
} from "shared-components/src/components/feedback/store/circularProgress.actions";
import {
  FETCH_WATER_SYSTEMS_REQUEST,
  fetchWaterSystemFailure,
  fetchWaterSystemSuccess,
} from "../../store/actions/waterSystems.actions";

const getWaterSystemsData = async (token) => {
  const url = `${API_WATER_AUTHORITY}`;
  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      populate: {
        water_systems: {
          populate: "*",
        },
      },
    },
  });

  return response.data;
};

function* handleWaterSystemsData() {
  try {
    const token = yield select((state) => state.auth.token);
    const waterAuthority = yield select(
      (state) => state.user?.data?.water_authority
    );
    yield put(showProgress());
    const response = yield call(getWaterSystemsData, token);

    const filteredData = response.data.filter(
      (item) =>
        item.id === waterAuthority.id ||
        (item.attributes && item.attributes.id === waterAuthority.id)
    );
    yield put(
      fetchWaterSystemSuccess({
        data: filteredData,
        meta: response.meta,
      })
    );
    yield put(hideProgress());
  } catch (error) {
    yield put(fetchWaterSystemFailure(error.message));
  }
}

export function* watchGetWaterSystems() {
  yield takeLatest(FETCH_WATER_SYSTEMS_REQUEST, handleWaterSystemsData);
}
